var __TEMP__ = require('./_baseGt.js');var baseGt = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_createRelationalOperation.js');var createRelationalOperation = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Checks if `value` is greater than `other`.
 *
 * @static
 * @memberOf _
 * @since 3.9.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 * @see _.lt
 * @example
 *
 * _.gt(3, 1);
 * // => true
 *
 * _.gt(3, 3);
 * // => false
 *
 * _.gt(1, 3);
 * // => false
 */
var gt = createRelationalOperation(baseGt);

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = gt;
